module.exports = __webpack_public_path__ + "static/media/T13-01.4e39b36c.svg";